const numericCharactersRegex = /[\d.]/;

export default numericCharactersRegex;
